import { ReactNode } from 'react';

import Button from '~components/Button';
import { WantedJobPostingResponse } from '~hooks/query/company/useWantedJobPosting';
import { Nullable } from '~types/common';

interface Props {
  wantedJobPosting?: WantedJobPostingResponse;
  PK_NM_HASH?: string;
}
interface CompanyInfo extends Partial<WantedJobPostingResponse> {
  sectionTitle?: string;
  rightCardHeader?: Nullable<ReactNode>;
  linkMore?: string;
}

export function useCompanyInfo({ wantedJobPosting, PK_NM_HASH }: Props): CompanyInfo {
  if (!wantedJobPosting) {
    return {};
  }

  return {
    sectionTitle: wantedJobPosting?.is_recommended ? '추천기업 채용 공고' : '채용 공고',
    rightCardHeader: wantedJobPosting.is_recommended ? undefined : (
      <Button
        variant='magenta'
        size='sm'
        as='a'
        href={`https://www.wanted.co.kr/company/${wantedJobPosting.company.id}`}
        target='_blank'
        data-attribute-id='company__position__seeMore'
        data-company-name={wantedJobPosting.company.name}
        data-company-hash={wantedJobPosting.PK_NM_HASH}
        data-connection={wantedJobPosting.is_recommended ? '추천기업 채용 공고' : '채용 공고'}>
        더 많은 공고 보기
      </Button>
    ),
    linkMore: `https://www.wanted.co.kr/company/${wantedJobPosting.company.id}`,
  };
}
